import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SspContext from '../../../../../selfServicePortal/contexts/SspContext'
import { checkIsMobile } from 'shared'
import { TableLegacy } from '../../../../components/index'
import MobileAnnualReport from './MobileAnnualReport/MobileAnnualReport'
import { IAnnualReport } from '../../../../../selfServicePortal/interfaces/i-api-creaditCard'
import getAnnualReportService from '../../../../services/CreditCardServices/getAnnualReportService'

const AnnualReport = () => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()

	const { overviewData } = useContext(SspContext)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState<Error>()
	const [data, setData] = useState<IAnnualReport>()

	useEffect(() => {
		async function getAnnualReport() {
			setLoading(true)
			await getAnnualReportService(overviewData?.accountAgreementId!, t)
				.then((data) => {
					setData(data)
				})
				.then(() => setLoading(false))
				.catch((error) => {
					console.log(error)
					setLoading(false)
					setError(error)
				})
		}
		getAnnualReport()
		// eslint-disable-next-line
	}, [])

	const cols = [
		t('Deposit'),
		t('UsedCredit'),
		t('RecieveInterest'),
		t('InterestPaid'),
		t('ValueDate'),
	]

	let itemsToRender
	if (data && !loading) {
		itemsToRender = (
			<tr>
				<td>{data.accountDebitBalance}</td>
				<td>{data.accountCreditBalance}</td>
				<td>{data.interestReceived}</td>
				<td>{data.interestPaid}</td>
				<td>{data.currency}</td>
			</tr>
		)
	}

	return (
		<div className="container">
			{loading ? (
				<div id="circle-spinner"></div>
			) : (
				<>
					{error ? (
						<div className="mt-3">{t(error.message)}</div>
					) : (
						<>
							{isMobile && data ? (
								<MobileAnnualReport data={data} />
							) : (
								<div className="fade-in annual-report outer-container p-3 mt-4">
									<div className="d-flex justify-content-between">
										<div>{t('AnnualReport')}</div>
									</div>
									<TableLegacy
										columns={cols}
										data={itemsToRender}
									/>
									<div className="d-flex justify-content-center"></div>
								</div>
							)}
						</>
					)}
				</>
			)}
		</div>
	)
}
export default AnnualReport
